/**
 * JourneyIcon — sanitized from `assets/newSvg/journey.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function JourneyIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M7.06089,16.8357 C7.54905,16.3476 8.3405,16.3476 8.82866,16.8357 C9.28426667,17.2913533 9.31464044,18.0111276 8.91978133,18.501997 L8.82866,18.6035 L6.53056,20.9016 C5.98138187,21.4507875 5.11232582,21.4851117 4.52316295,21.0045727 L4.40924,20.9016 L3.17178,19.6641 C2.68363,19.176 2.68363,18.3845 3.17178,17.8964 C3.627396,17.4407467 4.34721129,17.4103698 4.83805386,17.8052693 L4.93955,17.8964 L5.4699,18.4267 L7.06089,16.8357 Z M20.0002,17.4999 C20.8286,17.4999 21.5002,18.1715 21.5002,18.9999 C21.5002,19.8284 20.8286,20.4999 20.0002,20.4999 L12.0002,20.4999 C11.1718,20.4999 10.5002,19.8284 10.5002,18.9999 C10.5002,18.1715 11.1718,17.4999 12.0002,17.4999 L20.0002,17.4999 Z M8.82866,9.83572 C9.31681,10.3239 9.31681,11.1153 8.82866,11.6035 L6.53056,13.9016 C5.94477,14.4874 4.99503,14.4874 4.40924,13.9016 L3.17178,12.6641 C2.68363,12.176 2.68363,11.3845 3.17178,10.8964 C3.65994,10.4082 4.45139,10.4082 4.93955,10.8964 L5.4699,11.4267 L7.06089,9.83572 C7.54905,9.34757 8.3405,9.34757 8.82866,9.83572 Z M20.0002,10.4999 C20.8286,10.4999 21.5002,11.1715 21.5002,11.9999 C21.5002,12.7796647 20.9052879,13.4203567 20.1446558,13.4930341 L20.0002,13.4999 L12.0002,13.4999 C11.1718,13.4999 10.5002,12.8284 10.5002,11.9999 C10.5002,11.2202294 11.0951121,10.5794543 11.8557442,10.5067668 L12.0002,10.4999 L20.0002,10.4999 Z M7.06089,2.83572 C7.54905,2.34757 8.3405,2.34757 8.82866,2.83572 C9.28426667,3.291336 9.31464044,4.01115129 8.91978133,4.50199386 L8.82866,4.60349 L6.53056,6.90159 C5.98138187,7.45075875 5.11232582,7.4850818 4.52316295,7.00455914 L4.40924,6.90159 L3.17178,5.66413 C2.68363,5.17597 2.68363,4.38451 3.17178,3.89636 C3.627396,3.440744 4.34721129,3.4103696 4.83805386,3.8052368 L4.93955,3.89636 L5.4699,4.42671 L7.06089,2.83572 Z M20.0002,3.49995 C20.8286,3.49995 21.5002,4.17152 21.5002,4.99995 C21.5002,5.77964882 20.9052879,6.420399 20.1446558,6.49308345 L20.0002,6.49995 L12.0002,6.49995 C11.1718,6.49995 10.5002,5.82838 10.5002,4.99995 C10.5002,4.22025118 11.0951121,3.579501 11.8557442,3.50681655 L12.0002,3.49995 L20.0002,3.49995 Z"
        fill={color}
      />
    </Svg>
  );
}

export default JourneyIcon;
